
let React =               require("react");
let Model3DCard =         require("../cards/Model3DCard.jsx");
let Empty3DModelCard =    require("../empty/Empty3DModelCard.jsx");
let Upload3DModelButton = require("../buttons/Upload3DModelButton.jsx");
let DataListPage =        require("../../pages/generic/DataListPage.jsx");

class Model3DHub extends React.Component {

    constructor(){
        super()
    }

    shouldComponentUpdate(nextProps){
        return  Number(this.props.hub.id) !== Number(nextProps.hub.id) ||
                Boolean(this.props.hub.deleted) !== Boolean(nextProps.hub.deleted)
    }

    render() {
        const hubDeleted = Boolean(this.props.hub.deleted);

        const WrappedModel3DCard = props => <Model3DCard {...props} hubDeleted={hubDeleted}/>;
        const WrappedUpload3DModelButton = props => <Upload3DModelButton {...this.props} {...props} idHub={this.props.hub.id} hubDeleted={hubDeleted}/>;
        const WrappedEmpty3DModelCard = props => <Empty3DModelCard {...props} idHub={this.props.hub.id}/>;

        return  <DataListPage
                    {...this.props}
                    endpoint="/3dmodels/search?"
                    filtersEndpoint={{hub: this.props.hub.id}}
                    urlName="3dmodels"
                    displayName={`3D Models from "${this.props.hub.name}"`}
                    cssCardTag="package"
                    loginRequired
                    canSwitchLayout
                    showCover={false}
                    resetViewAfterNewUpload
                    showUploadNewAsset={!hubDeleted}
                    UploadNewAsset={WrappedUpload3DModelButton}
                    EmptyCard={WrappedEmpty3DModelCard}
                    CardType={WrappedModel3DCard}
                />
    }
}

module.exports = Model3DHub;
